import { Subscription } from 'rxjs';

function unsubscribeFromAllSubscriptionsOf(target) {
    for (const prop in target) {
        if (Object.hasOwnProperty.call(target, prop)) {
            const property = target[prop];
            if (property instanceof Subscription && !property.closed) {
                property.unsubscribe();
            } else if (property instanceof Array) {
                for (const propertyElement of property) {
                    if (propertyElement instanceof Subscription && !propertyElement.closed) {
                        propertyElement.unsubscribe();
                    }
                }
            }
        }
    }
}

export function AutoUnsubscribe(): MethodDecorator {
    return (_: any, __: string, descriptor: PropertyDescriptor) => {
        if (!descriptor || !descriptor.value) {
            throw new Error('OnDestroyUnsubscribe decorator can only be applied to the ngOnDestroy method.');
        }

        const originalMethod = descriptor.value;
        descriptor.value = function () {
            originalMethod.call(this);
            unsubscribeFromAllSubscriptionsOf(this);
        };
    };
}
